import React from "react";
import SupervisedUserCircleIcon from "@mui/icons-material/SupervisedUserCircle";
import PersonIcon from "@mui/icons-material/Person";
import SettingsIcon from "@mui/icons-material/Settings";
import HomeIcon from "@mui/icons-material/Home";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import UnfoldLessIcon from "@mui/icons-material/UnfoldLess";
import {
  COLORS,
  COLLECTIONS,
  BANNERS,
  COUPONS,
  NOTIFICATIONS,
  HOME,
  OFFICE_INVOICES,
  OFFICE_PRE_BOOK_ORDERS,
  PRODUCT_VARIANTS,
  PRODUCTS,
  OFFICE_PURCHASE_ORDERS,
  OFFICE_RETURNS,
  VENDORS,
  ROLES,
  USERS,
  OFFICE_PURCHASE_ORDERS_ADD,
  OFFICE_PURCHASE_ORDERS_EDIT,
  OFFICE_RETURNS_ADD,
  OFFICE_RETURNS_EDIT,
  OFFICE_RETURN_ADD_FROM_PRE_ORDER,
  PRODUCT_ADD,
  PRODUCT_EDIT,
  OFFICE_INVOICE_ADD,
  OFFICE_INVOICE_EDIT,
  OFFICE_ORDER_DISPATCHED,
  OFFICE_PRE_BOOK_ORDERS_ADD,
  OFFICE_PRE_BOOK_ORDERS_EDIT,
  MILL_PURCHASE,
  MILL_PURCHASE_EDIT,
  MILL_PURCHASE_ADD,
  KNITTER_ORDER,
  KNITTER_ORDER_ADD,
  KNITTER_ORDER_EDIT,
  VENDORS_MANAGE_PRICE,
  USERS_EDIT,
  USERS_ADD,
  OFFICE_PURCHASE_ADD_FROM_PRE_ORDER,
  OFFICE_INVOICE_Add_From_PO,
  MILL_PURCHASE_ADD_FROM_KNITTER_ORDER,
  LOGS_URL,
  OFFICE_ORDER_DISPATCHED_VIEW,
  PRODUCTS_INWARD,
  PRODUCTS_INWARD_ADD,
  PRODUCTS_LOW_STOCK,
  PRODUCTS_PROCESS_ADD,
  PRODUCTS_PROCESS,
  ALL_PRODUCTS,
  PARTY_RATE,
  PARTY_NUMBER,
  LEADS,
  LEAD_DETAIL,
} from "app/routes/constant";
import { Icon } from "@iconify/react";

const menus = [
  {
    label: "Dashboard",
    type: "section",
    children: [
      {
        uri: HOME,
        label: "Dashboard",
        type: "nav-item",
        icon: <HomeIcon sx={{ fontSize: 20 }} />,
        permission: "All",
      },
    ],
  },
  {
    label: "Product",
    type: "section",
    children: [
      {
        uri: PRODUCTS,
        label: "Product Manager",
        type: "nav-item",
        icon: (
          <Icon icon="fluent-mdl2:product-variant" width="24" height="24" />
        ),
        isActiveUri: [PRODUCTS, PRODUCT_ADD, PRODUCT_EDIT, PRODUCT_VARIANTS],
        moduleName: "Product",
        permission: "All",
      },
      {
        uri: ALL_PRODUCTS,
        label: "All Products",
        type: "nav-item",
        icon: (
          <Icon
            icon="lsicon:management-stockout-filled"
            width="24"
            height="24"
          />
        ),
        permission: "All",
      },
      {
        uri: PRODUCTS_INWARD,
        label: "Product Inward",
        type: "nav-item",
        icon: <UnfoldLessIcon sx={{ fontSize: 20 }} />,
        isActiveUri: [PRODUCTS_INWARD, PRODUCTS_INWARD_ADD],
        permission: "All",
      },
      {
        uri: PRODUCTS_LOW_STOCK,
        label: "Low Stock",
        type: "nav-item",
        icon: (
          <Icon
            icon="healthicons:low-level-outline-24px"
            width="24"
            height="24"
          />
        ),
        permission: "list-variant",
      },
    ],
  },
  {
    label: "Office Modules",
    type: "section",
    children: [
      {
        uri: OFFICE_PRE_BOOK_ORDERS,
        label: "Pre-Book Orders",
        type: "nav-item",
        icon: (
          <Icon
            icon="lsicon:work-order-appointment-filled"
            width="24"
            height="24"
          />
        ),
        isActiveUri: [
          OFFICE_PRE_BOOK_ORDERS,
          OFFICE_PRE_BOOK_ORDERS_ADD,
          OFFICE_PRE_BOOK_ORDERS_EDIT,
        ],
        moduleName: "Pre Book",
        permission: "list-pre-book",
      },
      {
        uri: OFFICE_PURCHASE_ORDERS,
        label: "PO (Purchase Order)",
        type: "nav-item",
        icon: <AddShoppingCartIcon sx={{ fontSize: 20 }} />,
        isActiveUri: [
          OFFICE_PURCHASE_ORDERS,
          OFFICE_PURCHASE_ORDERS_ADD,
          OFFICE_PURCHASE_ORDERS_EDIT,
          OFFICE_PURCHASE_ADD_FROM_PRE_ORDER,
        ],
        moduleName: "Purchase Order (PO)",
        permission: "list-purchase-order",
      },
      {
        uri: OFFICE_INVOICES,
        label: "Invoice",
        type: "nav-item",
        isActiveUri: [
          OFFICE_INVOICES,
          OFFICE_INVOICE_ADD,
          OFFICE_INVOICE_EDIT,
          OFFICE_INVOICE_Add_From_PO,
        ],
        icon: <Icon icon="basil:invoice-solid" width="24" height="24" />,
        moduleName: "Invoice",
        permission: "list-invoice",
      },
      {
        uri: OFFICE_ORDER_DISPATCHED,
        label: "Dispatched",
        type: "nav-item",
        icon: (
          <Icon icon="hugeicons:delivery-truck-01" width="24" height="24" />
        ),
        isActiveUri: [OFFICE_ORDER_DISPATCHED, OFFICE_ORDER_DISPATCHED_VIEW],
        permission: "dispatched-invoice",
      },
      {
        uri: OFFICE_RETURNS,
        label: "Return",
        type: "nav-item",
        icon: (
          <Icon
            icon="material-symbols:assignment-return-rounded"
            width="24"
            height="24"
          />
        ),
        isActiveUri: [
          OFFICE_RETURNS,
          OFFICE_RETURNS_ADD,
          OFFICE_RETURNS_EDIT,
          OFFICE_RETURN_ADD_FROM_PRE_ORDER,
        ],
        moduleName: "Return",
        permission: "list-return",
      },
      {
        uri: PARTY_RATE,
        label: "Party Rate",
        type: "nav-item",
        icon: <Icon icon="icomoon-free:price-tags" width="24" height="20" />,
        moduleName: "Party Rate",
        permission: "list-supplier-rate",
      },
      {
        uri: PARTY_NUMBER,
        label: "Party Number",
        type: "nav-item",
        icon: <Icon icon="mdi:card-account-phone" width="24" height="24" />,
        moduleName: "Party Number",
        permission: "list-party-number",
      },
      {
        uri: VENDORS,
        label: "Vendors",
        type: "nav-item",
        isActiveUri: [VENDORS, VENDORS_MANAGE_PRICE],
        icon: <PersonIcon sx={{ fontSize: 20 }} />,
        moduleName: "Supplier",
        permission: "list-supplier",
      },
    ],
  },
  {
    label: "Mill Modules",
    type: "section",
    children: [
      {
        uri: MILL_PURCHASE,
        label: "Purchase",
        type: "nav-item",
        icon: <Icon icon="mage:box-3d-plus" width="24" height="24" />,
        isActiveUri: [
          MILL_PURCHASE,
          MILL_PURCHASE_ADD,
          MILL_PURCHASE_EDIT,
          MILL_PURCHASE_ADD_FROM_KNITTER_ORDER,
        ],
        moduleName: "Mill Purchase",
        permission: "list-mill-purchase",
      },
      {
        uri: PRODUCTS_PROCESS,
        label: "Product Process",
        type: "nav-item",
        isActiveUri: [PRODUCTS_PROCESS, PRODUCTS_PROCESS_ADD],
        icon: <Icon icon="clarity:process-on-vm-line" width="24" height="24" />,
        // moduleName: "Product Process",
        permission: "All",
      },
      // {
      //   uri: MILL_ORDERS,
      //   label: "Orders",
      //   type: "nav-item",
      //   isActiveUri: [MILL_ORDERS, MILL_ORDER_ADD, MILL_ORDER_EDIT],
      //   icon: <Icon icon="fa6-solid:box-open" width="24" height="24" />,
      //   moduleName: "Mill Order",
      //   permission: "list-mill-order",
      // },
    ],
  },
  {
    label: "Knitter Modules",
    type: "section",
    children: [
      {
        uri: KNITTER_ORDER,
        label: "Orders",
        type: "nav-item",
        isActiveUri: [KNITTER_ORDER, KNITTER_ORDER_ADD, KNITTER_ORDER_EDIT],
        icon: <Icon icon="fluent:box-16-filled" width="20" height="20" />,
        moduleName: "Knitter Order",
        permission: "list-knitter-order",
      },
    ],
  },
  {
    label: "Logs",
    type: "section",
    children: [
      {
        uri: LOGS_URL,
        label: "Logs",
        type: "nav-item",
        icon: <Icon icon="tabler:logs" width="20" height="20" />,
        permission: "list-accountLog",
      },
    ],
  },
  {
    label: "Lead Management",
    type: "section",
    children: [
      {
        uri: LEADS,
        label: "Lead Management",
        type: "nav-item",
        icon: <Icon icon="mdi:account-group" width="24" height="24" />,
        isActiveUri: [LEADS, LEAD_DETAIL],
        moduleName: "Lead",
        permission: "list-lead",
      },
    ],
  },
  {
    label: "Settings",
    type: "section",
    children: [
      {
        label: "Settings",
        type: "collapsible",
        icon: <SettingsIcon sx={{ fontSize: 20 }} />,
        // permission: "All",
        children: [
          {
            uri: ROLES,
            label: "Roles & Permissions",
            type: "nav-item",
            moduleName: "Role",
            permission: "list-role",
          },
          {
            uri: USERS,
            label: "Users",
            type: "nav-item",
            isActiveUri: [USERS, USERS_ADD, USERS_EDIT],
            icon: <SupervisedUserCircleIcon sx={{ fontSize: 20 }} />,
            moduleName: "User",
            permission: "list-user",
          },
          {
            uri: COLORS,
            label: "Colors",
            type: "nav-item",
            moduleName: "Color",
            permission: "list-color",
          },
          {
            uri: COLLECTIONS,
            label: "Collections",
            type: "nav-item",
            moduleName: "Collection",
            permission: "list-collection",
          },
          {
            uri: BANNERS,
            label: "Banners",
            type: "nav-item",
            moduleName: "Banner",
            permission: "list-banner",
          },
          {
            uri: COUPONS,
            label: "Coupons",
            type: "nav-item",
            moduleName: "Coupon",
            permission: "list-coupon",
          },
          {
            uri: NOTIFICATIONS,
            label: "Notifications",
            type: "nav-item",
            moduleName: "Notification",
            permission: "list-supplier-notification",
          },

        ],
      },
    ],
  },
];

export default menus;
